import 'vidstack/player/styles/default/theme.css';
import 'vidstack/player/styles/default/layouts/video.css';
import './css/main.css';


import barba from '@barba/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


import '@mux/mux-player';
import 'vidstack/player';
import 'vidstack/player/ui';

import { init } from '@plausible-analytics/tracker';

init({
  domain: 'shiftintoyourfuture.com'
});


barba.init({
  debug: true,
  timeout: 7000,
  transitions: [
    {
      name: 'opacity-transition',
      leave(data) {
        return gsap.to(data.current.container, {
          opacity: 0
        });
      },
      // * MA added this beforeEntry bit
      beforeEnter: function beforeEnter(data) {},
      enter(data) {},
      after(data) {
        return gsap.from(data.next.container, {
          opacity: 0
        });
      },
      afterOnce(data) {},
      once(data) {}
    }
  ]
});

function scrollToTop() {
  // window.scrollTo({top: 0, behavior: 'smooth'});
  window.scrollTo({ top: 0 });
}

history.scrollRestoration = "manual";
let scrollPosY = [0];


function initWorkshopCarousel() {
  if (!document.querySelector('.workshopSwiper')) return;
  import(/* webpackChunkName: "workshopCarousel" */ "./js/components/workshopCarousel.js").then(module => {
    module.default();
  });
}

function initFaqAccordion() {
  if (!document.querySelector('[data-faq]')) return;
  import(/* webpackChunkName: "faqAccordion" */ "./js/components/faqAccordion.js").then(module => {
    module.default();
  });
}

function initFilmOverlay() {
  if (!document.querySelector('[data-film-trigger]')) return;
  import(/* webpackChunkName: "filmOverlay" */ "./js/components/filmOverlay.js").then(module => {
    module.default();
  });
}

function initPortalCountdown() {
  if (!document.getElementById('portalServerTime')) return;
  import(/* webpackChunkName: "portalCountdown" */ "./js/components/portalCountdown.js").then(module => {
    module.default();
  });
}

function initPortalPlayer() {
  if (!document.querySelector('[data-portal-player]')) return;
  import(/* webpackChunkName: "portalPlayer" */ "./js/components/portalPlayer.js").then(module => {
    module.default();
  });
}

function initPortalForm() {
  const form = document.getElementById('portalYearForm');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    window.location.href = '/student-portal/' + document.getElementById('yearSelect').value;
  });
}

function hamburgerToggle(preset) {
    import(/* webpackChunkName: "hamburgerToggle" */ "./js/components/hamburgerToggle.js").then(module => {
      const toggle = module.default;
      toggle(preset);
    });
  }

let hamburgerOuter = document.getElementById("hamburgerOuter");
if (hamburgerOuter) {
  hamburgerOuter.addEventListener("click", function() {hamburgerToggle()});
}

let menuBackdrop = document.getElementById("menuBackdrop");
if (menuBackdrop) {
  menuBackdrop.addEventListener("click", function() {hamburgerToggle('c')});
}

barba.hooks.once(data => {
  initWorkshopCarousel();
  initFaqAccordion();
  initFilmOverlay();
  initPortalCountdown();
  initPortalPlayer();
  initPortalForm();
});

barba.hooks.afterOnce(data => {
  
});

barba.hooks.before(data => {
  if(data.trigger !== "back") {
    scrollPosY.push(barba.history.current.scroll.y);
  }
  hamburgerToggle('c');
  const overlay = document.getElementById('filmOverlay');
  if (overlay && !overlay.classList.contains('hidden')) {
    overlay.classList.add('hidden');
    overlay.classList.remove('flex');
    const player = document.getElementById('filmPlayer');
    if (player) player.pause();
  }
});

barba.hooks.enter(data => {
  
  
});

barba.hooks.beforeEnter(data => {
});

barba.hooks.after(data => {
  initWorkshopCarousel();
  initFaqAccordion();
  initFilmOverlay();
  initPortalCountdown();
  initPortalPlayer();
  initPortalForm();
  // subMenuToggle('open');
  if(data.trigger !== "back") {
    window.scrollTo(0,0);
  } else {
    setTimeout(() => {window.scrollTo(0, scrollPosY.pop())}, 100);
    // console.log(scrollPosY)
  }


});
